import { render, staticRenderFns } from "./PrenotazioniCupList.vue?vue&type=template&id=7c210ec5"
import script from "./PrenotazioniCupList.vue?vue&type=script&lang=js"
export * from "./PrenotazioniCupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports